module.exports = __webpack_public_path__ + "static/media/cloud_left.9ce97759.svg";